import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

import { currentYear } from '@/utils/date';
import { useRouteMatcher } from '@/utils/url';

import Constants from '@/constants';

const Footer = () => {
  const routeMatches = useRouteMatcher();
  const isOnDocumentPage = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.DocumentPath,
  );
  const isOnAiExperimentsPage = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.AiExperimentsPath,
  );

  const { t } = useTranslation();

  const shouldShowFooter = !isOnDocumentPage && !isOnAiExperimentsPage;

  return (
    shouldShowFooter && (
      <div className="flex w-full items-center justify-center">
        <Typography className="mx-0! mt-18! mb-6!" variant="caption1">
          {`©${currentYear} ${t('Generic.footer')}`}
        </Typography>
      </div>
    )
  );
};

export default Footer;
